"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../tokens/types");
function anyValue(value) {
    return [{
            type: types_1.TokenType.ANY_VALUE,
            value,
        }];
}
exports.default = anyValue;
